module.exports = __webpack_public_path__ + "static/media/lazyaz_app3.269b1331.jpg";